export default "__VITE_ASSET__SXcmErHD__"